import styled from "@emotion/styled";
export const StyledFactCardsComponent = styled.div`
  display: flex;
  flex-direction: column;

  .header {
    margin-bottom: 48px;
  }
`;
